import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, removeClass, addClass, findAllIn, closest, findIn} from "@elements/dom-utils";

export function init() {
    onFind('.js-ajax-form', function ($element) {
        on('fetch.ajax-form', function () {

            /*scroll back to top on fetch*/
            let offset = $element.getBoundingClientRect().top + window.pageYOffset;

            let $filterOverlay = findIn('.js-overlay', $element);
            if ($filterOverlay && hasClass('is-open', $filterOverlay)) {
                removeClass('is-open', $filterOverlay);
            }

            if (window.pageYOffset > offset) {
                try {
                    window.scroll({
                        top: offset,
                        behavior: 'smooth'
                    });
                } catch (e) {
                    window.scrollTo(0, offset)
                }
            }

            /*set paging correct if it is not in result*/
            let pageLinks = findAllIn('.js-ajax-form__link', $element);
            if (pageLinks.length > 0) {
                let pageParam = new URLSearchParams(window.location.search).get('page');
                pageParam = pageParam !== null ? pageParam : 1;

                pageLinks.forEach(function (link) {
                    if (link.textContent.trim() === pageParam.toString()) {
                        pageLinks.forEach(function (pageLink) {
                            if(closest('.pagination', link) === closest('.pagination', pageLink)){
                                removeClass('active', pageLink.parentElement)
                            }
                        });
                        addClass('active', link.parentElement);
                    }
                });
            }

        }, $element);
    });
}
